var map = {
	"./fig01.jpg": "e583",
	"./fig02.jpg": "acfc",
	"./fig03.jpg": "320d",
	"./fig04.jpg": "c851",
	"./fig05.jpg": "207f",
	"./fig06.jpg": "7365",
	"./fig07.jpg": "493b",
	"./fig08.jpg": "bf0b",
	"./fig09.jpg": "1d92",
	"./fig10.jpg": "0d06",
	"./fig11.jpg": "d716",
	"./fig12.jpg": "a08b",
	"./fig13.jpg": "dfb8",
	"./fig14.jpg": "d59a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fc6";